import * as yup from "yup";

export const AssetsUpdateSchema = yup.object().shape({
  resourceName: yup.string().required("Required"),
  companyName: yup.string(),
  vendor: yup.string(),
  deploymentDate: yup.date(),
  warrantyPeriod: yup.number(),
  paymentAmount: yup.number(),
  paymentMode: yup.string(),
  uploadBill: yup
    .mixed()
    .test("is-valid-size", "Max allowed size is 10MB", (value) => {
      if (value && value.size) {
        return value.size <= 10 * 1024 * 1024;
      } else {
        return true;
      }
    }),
  uploadWarrantyCard: yup
    .mixed()
    .test("is-valid-size", "Max allowed size is 10MB", (value) => {
      if (value && value.size) {
        return value.size <= 10 * 1024 * 1024;
      } else {
        return true;
      }
    }),
  notes: yup.string(),
  uploadProductPhoto: yup
    .mixed()
    .test("is-valid-size", "Max allowed size is 10MB", (value) => {
      if (value && value.size) {
        return value.size <= 10 * 1024 * 1024;
      } else {
        return true;
      }
    }),
});
